import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';

export interface SitemapLink {
  route: string;
  labelKey: string;
}

export interface SitemapSection {
  titleKey: string;
  links: SitemapLink[];
}

@Component({
  selector: 'app-footer-sitemap',
  templateUrl: './footer-sitemap.component.html',
  styleUrls: ['./footer-sitemap.component.scss'],
})
export class FooterSitemapComponent implements OnInit {
  readonly sections: SitemapSection[] = [
    {
      titleKey: 'FOOTER.SITEMAP_MAIN_PAGES',
      links: [
        { route: '/main', labelKey: 'FOOTER.SITEMAP_HOME' },
        { route: '/about-us', labelKey: 'FOOTER.SITEMAP_ABOUT' },
        { route: '/blog', labelKey: 'FOOTER.SITEMAP_BLOG' },
        { route: '/contact', labelKey: 'FOOTER.SITEMAP_CONTACT' },
      ],
    },
    {
      titleKey: 'FOOTER.SITEMAP_SERVICES',
      links: [
        { route: '/management-tool', labelKey: 'FOOTER.SITEMAP_PROPERTY_MANAGEMENT' },
        { route: '/todo', labelKey: 'FOOTER.SITEMAP_TASK_MANAGEMENT' },
        { route: '/documents', labelKey: 'FOOTER.SITEMAP_DOCUMENT_MANAGEMENT' },
        { route: '/calculators', labelKey: 'FOOTER.SITEMAP_CALCULATORS' },
        { route: '/help', labelKey: 'HOME.HELP_CENTER_TITLE' },
      ],
    },
    {
      titleKey: 'FOOTER.SITEMAP_LEGAL',
      links: [
        { route: '/legal/terms', labelKey: 'FOOTER.SITEMAP_TERMS' },
        { route: '/legal/privacy-policy', labelKey: 'FOOTER.SITEMAP_PRIVACY' },
        { route: '/legal/cookie-preferences', labelKey: 'FOOTER.SITEMAP_COOKIES' },
        { route: '/legal/privacy', labelKey: 'FOOTER.SITEMAP_LEGAL_NOTES' },
        { route: '/collaboration', labelKey: 'FOOTER.MENU_COLLABORATION' },
        { route: '/careers', labelKey: 'FOOTER.CAREERS_TITLE' },
      ],
    },
  ];

  constructor(
    public translate: TranslateService,
    private trackerService: TrackerService
  ) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
  }
}
